import styled from 'styled-components';

export const PageHeaderH1 = styled.h1`
	padding: 2rem 1rem 1rem;
	border-bottom: 1px solid var(--ion-color-medium);
	display: flex;
	gap: 0.5rem;
	align-items: center;
	ion-icon {
		font-size: 2.5rem;
        color: #257226;//var(--ion-color-secondary);

	}
`;

export const PageDesctiption = styled.div`
	padding: 0 1rem;
	font-size: 0.875rem;
	color: var(--ion-color-primary);
	padding-bottom: 0.75rem;
	border-bottom: 1px solid var(--ion-color-medium);
	p:first-child {
		margin-top: 0;
	}
	p:last-child {
		margin-bottom: 0;
	}
`;
